import React from 'react';
import ReactDOM from 'react-dom';
import Dict from 'dict-lib';
import FontAwesome from "react-fontawesome";
import {Modal, Button, Row, Col, Glyphicon} from 'react-bootstrap';
import Tree, {TreeNode} from 'draggable-react-tree-component';
import cssAnimation from 'css-animation';
import {TreeDOMHelper, TreeNodeHelper, TreeUtilities} from "../../../dict-components/tree/components/TreeHelper";
import GridLayout from "react-grid-layout";
import stylesMorphoRule from "../../../_css/dictionary/lexemeParts/lexemeMorphoRule.module.css";
import BUtils from './../../../utilities/BaseUtilities';
import ReactTooltip from "react-tooltip";
import {MorphoRuleEdit} from './MorphoRuleEdit';
import {arrayMove, SortableContainer, SortableElement, SortableHandle} from "react-sortable-hoc";
import stylesSorter from "../../../_css/sorter.module.css";
import {MorphoRuleGridLayout} from "./MorphoRuleGridLayout";

function animate(node, show, done) {
    let height = node.offsetHeight;

    return cssAnimation(node, 'collapse', {
        start() {
            if (!show) {
                node.style.height = height + 'px';
            } else {
                height = node.offsetHeight;
                node.style.height = 0;
            }
        },
        active() {
            node.style.height = show ? height + 'px' : 0;
        },
        end() {
            node.style.height = '';
            done();
        },
    })
}

export class MorphoRuleSchema extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: true,
            expandedKeys: [],
            selectedKeys: [],
            autoExpandParent: true,
            treeStructure: [],
            openEditor: false
        };

        this._close = this._close.bind(this);
        this._promise = null;

        [
            'onExpand',
            'onLoadData',
            '_close'
        ].forEach((name) => (this[name] = this[name].bind(this)));
    }

    componentWillMount() {
        this._promise = Dict.call('/declinedForms/getLanguageToMarker/' + this.props.languageId + '/').then((result) => {
            this.setState({
                languageToMarker: result.languageToMarker,
            });
            this._loadMorphoRules();
        });
    }

    _loadMorphoRules() {
        Dict.call('/declinedForms/getMorphoRules/' + this.props.languageId + '/').then((treeStructure) => {
            this.setState({treeStructure});
        });
    }

    _close() {
        this.setState({showModal: false}, () => {
            this.emptyModalContainer();
        });
    }

    emptyModalContainer() {
        setTimeout(function () {
            ReactDOM.unmountComponentAtNode(document.getElementById("dict-modal-container"));
        }, 500);
    }

    onExpand(expandedKeys, treeNode) {
        //const items = treeNode.node.props.children.props.items;

        this.setState({
            expandedKeys,
            autoExpandParent: false,
        }, function () {
            TreeDOMHelper.resetItemSelection();
        })
    }


    onLoadData(treeNode) {
        const item = treeNode.props.children.props.item;
        this._performLoadData(item);
    }

    _performLoadData(item, callback) {
        if (!item.children) {
            Dict.call('/declinedForms/loadChildren/' + item.key + '/').then((newItem) => {
                var treeStructure = [...this.state.treeStructure];
                item.children = newItem.children;
                item.isLeaf = newItem.isLeaf;
                item.parentKey = newItem.parentKey;
                this.setState({treeStructure, lastRenderKey: item.children[item.children.length - 1].key}, () => {
                    if (typeof callback !== 'undefined')
                        callback();
                });
            });
        } else if (typeof callback !== 'undefined')
            callback();
    }

    _openEdit(operation, item, isAsync) {
        const selectedKeys = typeof item === 'undefined' ? [] : [item.key];
        this.setState({openEditor: true, selectedKeys});
        var componentToOpen = '';
        const container = document.getElementById('morpho-rule-schema-col-2');
        if (operation === 'EDIT' || operation === 'ADD') {
            const isAdd = operation === 'ADD';
            componentToOpen = <MorphoRuleEdit
                treeStructure={this.state.treeStructure}
                parent={isAdd && typeof item !== 'undefined' ? item : null}
                item={isAdd ? undefined : item} resetOpen={true}
                languageId={this.props.languageId}
                languageToMarker={this.state.languageToMarker}
                callbackParentOpen={(parent) => {
                    this._openEdit('EDIT', parent);
                }
                }

                callbackParentReloadTree={(newItem) => {
                    this._loadMorphoRules();
                    if (typeof newItem !== 'undefined') {
                        ReactDOM.unmountComponentAtNode(container);
                        this._openEdit('EDIT', newItem);
                    }
                }}
            />;
        } else if (operation === 'REMOVE') {
            componentToOpen = <div>
                <span style={{marginRight: '5px'}}><span style={{
                    fontWeight: 'bold',
                    marginRight: '3px'
                }}>{item.title}:</span>{Dict.t('ASK_DELETE_RULE')}</span>
                <span>
                    <Button style={{marginRight: '3px'}}
                            onClick={() => {
                                Dict.call('/declinedForms/removeRule/' + item.key + '/').then((result) => {
                                    this._loadMorphoRules();
                                    ReactDOM.unmountComponentAtNode(container);
                                })
                            }
                            }
                    >{Dict.t('YES')}</Button>
                    <Button onClick={() => {
                        ReactDOM.unmountComponentAtNode(container);
                    }
                    }>{Dict.t('NO')}</Button>
                </span>
            </div>
        } else if (operation === 'CLONE') {
            componentToOpen = <div>
                <span style={{marginRight: '5px'}}><span style={{
                    fontWeight: 'bold',
                    marginRight: '3px'
                }}>{item.title}:</span>{Dict.t('ASK_CLONE_RULE')}</span>
                <span>
                    <Button style={{marginRight: '3px'}}
                            onClick={() => {
                                Dict.call('/declinedForms/cloneRule/' + item.key + '/').then((result) => {
                                    this._loadMorphoRules();
                                    var newItem = {
                                        key: result.id,
                                        title: result.uniqueDescription,
                                        isLeaf: true,
                                        children: []
                                    };
                                    ReactDOM.unmountComponentAtNode(container);
                                    this._openEdit('EDIT', newItem);
                                })
                            }
                            }
                    >{Dict.t('YES')}</Button>
                    <Button onClick={() => {
                        ReactDOM.unmountComponentAtNode(container);
                    }
                    }>{Dict.t('NO')}</Button>
                </span>
            </div>
        } else if (operation === 'SORT') {
            this._performLoadData(item, () => {
                var itemList = item.children.map((child, index) =>
                    <div key={"key-tree-item-sortable-" + index}>
                        {child.title}
                    </div>
                );

                const DragHandle = SortableHandle(() => <div className="items-sortable-handle sortable-handle">
                    <Glyphicon glyph="sort"/>
                </div>);

                const SortableItem = SortableElement(({value}) => {
                    return (
                        <div
                            className={BUtils.joinClasses(stylesSorter['items-sortable-item'], stylesSorter['sortable-item'])}>
                            <DragHandle/>
                            {value}
                        </div>
                    );
                });

                const SortableList = SortableContainer(({items}) => {
                    return (
                        <div className={"div-sortable-container sortable-type-" + this.props.type}>
                            {items.map((value, index) => (
                                <SortableItem key={'sortable-item-' + index} index={index} value={value}/>
                            ))}
                        </div>
                    );
                });

                componentToOpen = <SortableList key={"key-lex-items-sortable"}
                                                helperClass={stylesSorter['sortableHelper']} pressDelay={0} lockAxis={"y"}
                                                useDragHandle={false}
                                                items={itemList}
                                                onSortStart={(obj) => {
                                                }}
                                                onSortEnd={(obj) => {
                                                    var sortedChildren = arrayMove(item.children, obj.oldIndex, obj.newIndex);
                                                    item.children = sortedChildren;
                                                    this._openEdit('SORT', item);

                                                    var ids = sortedChildren.map((schild) => {
                                                        return schild.key;
                                                    }).join('_');

                                                    Dict.call('/declinedForms/sortRules/' + ids + '/').then((result) => {
                                                        //this._loadMorphoRules();
                                                    });
                                                }}/>;

                this._renderComponentToOpen(componentToOpen);
            });
        } else if (operation === 'EDIT_SCHEMA') {
            const p = {
                className: "layout",
                items: 20,
                rowHeight: 30,
                onLayoutChange: function () {
                },
                cols: {lg: 12, md: 10, sm: 6, xs: 4, xxs: 2},
                ruleId: this.state.selectedKeys[0]
            };


            componentToOpen = <MorphoRuleGridLayout {...p} />;
            this._renderComponentToOpen(componentToOpen);
        }

        if (!isAsync)
            this._renderComponentToOpen(componentToOpen);
    }


    _renderComponentToOpen(componentToOpen) {
        const container = document.getElementById('morpho-rule-schema-col-2');
        ReactDOM.unmountComponentAtNode(container);
        ReactDOM.render(componentToOpen, container);
    }


    render() {

        const animation = {
            enter(node, done) {
                return animate(node, true, done)
            },
            leave(node, done) {
                return animate(node, false, done)
            },
            appear(node, done) {
                return animate(node, true, done)
            },
        };

        var languageToMarkerPromise = this._promise;
        const loop = data => (
            data.map((item) => {
                    return <TreeNode
                        className={"drag-not-over " + "tree-li"}
                        id={"id-" + item.title}
                        isLeaf={item.isLeaf}
                        key={item.key}
                        /*items={goLoop && (typeof visibleChildren !== 'undefined' && visibleChildren.length > 0) ? loop(visibleChildren) : null}*/
                        items={item.children && item.children.length > 0 ? loop(item.children) : null}
                        openAnimation={animation}
                    ><MorphoRuleTreeItem
                        item={item}
                        callbackCallOperation={(operation, isAsync) => {
                            languageToMarkerPromise.then(() => {
                                this._openEdit(operation, item, isAsync);
                            });
                        }}
                    />
                    </TreeNode>
                }
            )
        );


        return <Modal id="morpho-rule-schema" show={this.state.showModal} onHide={this._close} keyboard={false} restoreFocus>
            <Modal.Header closeButton>
                <Modal.Title>
                    <span>{Dict.t('MORPHO_RULES')}</span>
                    <span
                        className={BUtils.joinClasses(stylesMorphoRule['morpho-rule-markers-loading'], stylesMorphoRule['morpho-rule-markers-loading--' + (typeof this.state.languageToMarker === 'undefined')])}>Attesa caricamento marcatori <FontAwesome
                        name={"spinner"} spin/>
                    </span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Col lg={4} md={4} className={stylesMorphoRule['morpho-rule-schema-col-1']}>
                    <Row className={stylesMorphoRule['morpho-rule-add-new-root']}>
                        <Button onClick={() => {
                            languageToMarkerPromise.then(() => {
                                this._openEdit('ADD');
                            });
                        }}>
                            <FontAwesome name={'plus'}/>
                        </Button>
                    </Row>
                    <Row>
                        <Tree
                            expandedKeys={this.state.expandedKeys}
                            draggable={true}
                            onExpand={this.onExpand}
                            loadData={this.onLoadData}
                            autoExpandParent={this.state.autoExpandParent}
                            onSelect={this.onSelect}
                            multiple={true}
                            selectedKeys={this.state.selectedKeys}
                            /*onRightClick={(evt) => evt.node.selectHandle.children[1].classList.add('node-right-selected')}*/
                            openAnimation={animation}
                        >
                            {loop(this.state.treeStructure)}
                        </Tree>
                    </Row>
                </Col>
                <Col id={'morpho-rule-schema-col-2'} lg={8} md={8}
                     className={BUtils.joinClasses(stylesMorphoRule['morpho-rule-schema-col-2'], stylesMorphoRule['morpho-rule-schema-col-2--' + this.state.openEditor])}>
                </Col>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={this._close}>Close</Button>
            </Modal.Footer>
        </Modal>
    }
}

class MorphoRuleTreeItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this._openEdit = this._openEdit.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    _openEdit(operation, isAsync) {
        this.props.callbackCallOperation(operation, isAsync);
    }

    render() {

        const dataTip = 'edit-morpho-rule-' + this.props.item.key;

        return <>
            <div className={BUtils.joinClasses(stylesMorphoRule['morpho-rule-item'])}>
                <div onClick={() => {
                    this._openEdit('EDIT');
                }
                }>{this.props.item.title}</div>
                <div className={BUtils.joinClasses(stylesMorphoRule['morpho-rule-buttons'])}>
                    <Button data-tip data-for={dataTip + 1} onClick={() => {
                        this._openEdit('EDIT')
                    }}>
                        <FontAwesome name={'pencil'}/>
                        <ReactTooltip id={dataTip + 1} className={'morpho-rule-tooltip'} type='info' delayShow={500}>
                            <span>{Dict.t('EDIT')}</span>
                        </ReactTooltip>
                    </Button>
                    <Button data-tip data-for={dataTip + 2} onClick={() => {
                        this._openEdit('ADD')
                    }}>
                        <FontAwesome name={'plus'}/>
                        <ReactTooltip id={dataTip + 2} className={'morpho-rule-tooltip'}
                                      type='info' delayShow={500}>
                            <span>{Dict.t('ADD')}</span>
                        </ReactTooltip></Button>
                    <Button data-tip data-for={dataTip + 3} onClick={() => {
                        this._openEdit('CLONE')
                    }}>
                        <FontAwesome name={'clone'}/>
                        <ReactTooltip id={dataTip + 3} className={'morpho-rule-tooltip'}
                                      type='info' delayShow={500}>
                            <span>{Dict.t('CLONE')}</span>
                        </ReactTooltip></Button>
                    {this.props.item.isLeaf ? <>
                        <Button data-tip data-for={dataTip + 4} onClick={() => {
                            this._openEdit('REMOVE')
                        }}>
                            <FontAwesome name={'trash'}/>
                            <ReactTooltip id={dataTip + 4} className={'morpho-rule-tooltip'}
                                          type='info' delayShow={500}>
                                <span>{Dict.t('REMOVE')}</span>
                            </ReactTooltip></Button>
                    </> : ''}
                    {!this.props.item.isLeaf ? <Button data-tip data-for={dataTip + 5} onClick={() => {
                        this._openEdit('SORT')
                    }}>
                        <FontAwesome name={'sort-alpha-asc'}/>
                        <ReactTooltip id={dataTip + 5}
                                      className={'morpho-rule-tooltip'}
                                      type='info' delayShow={500}>
                            <span>{Dict.t('SORT_CHILDREN')}</span>
                        </ReactTooltip>
                    </Button> : ''}
                    <Button data-tip data-for={dataTip + 6} onClick={() => {
                        this._openEdit('EDIT_SCHEMA')
                    }}>
                        <FontAwesome name={'table'}/>
                        <ReactTooltip id={dataTip + 6} className={'morpho-rule-tooltip'}
                                      type='info' delayShow={500}>
                            <span>{Dict.t('EDIT_SCHEMA')}</span>
                        </ReactTooltip>
                    </Button>
                </div>
            </div>
        </>
    }
}


